import { render, staticRenderFns } from "./linkages.vue?vue&type=template&id=7f7eb93a&scoped=true&"
import script from "./linkages.vue?vue&type=script&lang=js&"
export * from "./linkages.vue?vue&type=script&lang=js&"
import style0 from "./linkages.vue?vue&type=style&index=0&id=7f7eb93a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7eb93a",
  null
  
)

export default component.exports